import "./styles/Parceiros.css"
// import SensorJetLogo from "./assets/images/Sensorjetlogo.png";
import WSAlogo from "./assets/images/WSAlogo.png";
import Carmetallogo from "./assets/images/Carmetallogo.png";

function Parceiros() {
  const parceiros = [
    {
      nome: "Agrotech",
      logo: "./assets/images/Agrotechlogo.png",
    },
    {
      nome: "Cotrijal",
      logo: "./assets/images/Cotrijallogo.png",
    },
    {
      nome: "JV Pulverteck",
      logo: "./assets/images/JVlogo.png",
    },
    {
      nome: "MRS Agro",
      logo: "./assets/images/MRSlogo.png",
    },
    {
      nome: "SensorJet",
      logo: "./assets/images/Sensorjetlogo.png",
    },
    {
      nome: "WSA Brasil",
      logo: WSAlogo,
    },
    {
      nome: "Carmetal",
      logo: Carmetallogo,
    },
  ]
  return ( 
    <div className="parceiros-container">
      <div className="parceiros-tittle-container">
        <div className="tittle">
          Nossos Parceiros
        </div>
      </div>
      <div className="parceiros-content-container">
        {parceiros.map((parceiro) => (
          <div className="parceiro-container" key={parceiro.nome}>
            <span>{parceiro.nome}</span>
            <img src={parceiro.logo} alt=""/>
          </div>
        ))}
      </div>
    </div>
    );
}

export default Parceiros;
